/**
 * open Context Menu
 * @param selector
 * @param type
 */
window.openContextMenu = function (selector, type = '') {
    const contextMenu = selector.find('.context-menu');
    const positionY = selector.offset().top;
    const positionX = selector.offset().left;

    $('body').addClass('context-menu-open').append('<div class="context-menu-layer" ' + (type === 'dialog' ? 'style="z-index:9999;"' : '') + '></div>');
    contextMenu.clone().appendTo('body');
    contextMenu.addClass('context-menu--open');

    const bodyContextMenu = $('body > .context-menu');
    const bodyContextMenuLayer = $('body > .context-menu-layer');

    bodyContextMenu.css({
        'top': positionY + 'px',
        'left': positionX + 'px',
    });

    updateContextMenuFlexibleWidth(bodyContextMenu);

    // layer click event
    bodyContextMenuLayer.on('click', function () {
        // close context menu if closed next to the menu
        closeContextMenu();
    });
};

/**
 * Open Kultur Context Menu
 * @param selector
 */
window.openKulturContextMenu = function (selector) {
    const contextMenu = selector.find('.context-menu');
    const positionY = selector.offset().top;
    const positionX = selector.offset().left;

    $('body').addClass('context-menu-open').append('<div class="context-menu-layer"></div>');
    contextMenu.clone().appendTo('body');

    const bodyContextMenu = $('body > .context-menu');
    const bodyContextMenuLayer = $('body > .context-menu-layer');

    bodyContextMenu.css({
        'top': positionY + 'px',
        'left': positionX + 'px',
    });

    if (bodyContextMenu.hasClass('context-menu--flexible')) {
        updateContextMenuFlexibleWidth(bodyContextMenu);
    }

    // layer click event
    bodyContextMenuLayer.on('click', function () {
        // close context menu if closed next to the menu
        closeContextMenu();
    });
};

/**
 * close Context Menu
 */
window.closeContextMenu = function () {
    const body = $('body');
    if (body.hasClass('context-menu-open')) {
        const bodyContextMenu = $('body > .context-menu');
        const bodyContextMenuLayer = $('body > .context-menu-layer');

        body.removeClass('context-menu-open');
        bodyContextMenu.remove();
        bodyContextMenuLayer.remove();

        $('.context-menu.context-menu--open').removeClass('context-menu--open');
    }
};

/**
 * updateContextMenuFlexibleWidth
 * @param contextMenu
 */
window.updateContextMenuFlexibleWidth = function (contextMenu) {
    if (contextMenu.children('ul').length) {
        const contextMenuUl = contextMenu.children('ul');
        const contextMenuWidth = contextMenuUl.width();
        const contextMenuOuterWidth = contextMenuUl.outerWidth();
        let contextMenuItemsWidth = 0;
        if (contextMenuUl.children('li').length) {
            contextMenuUl.children('li').each(function () {
                contextMenuItemsWidth += $(this).outerWidth();
            });
        }

        if ((contextMenuItemsWidth !== 0) && (contextMenuWidth > contextMenuItemsWidth)) {
            contextMenu.css('width', (contextMenuItemsWidth + (contextMenuOuterWidth - contextMenuWidth)) + 'px');
        }
    }
};

/**
 * replaceContextMenu
 */
window.replaceContextMenu = function () {
    const cloneContextMenuTrigger = $('#clone-context-menu-trigger');
    const contextType = $('.context-type').clone();

    cloneContextMenuTrigger.html('');
    cloneContextMenuTrigger.html(contextType);
    cloneContextMenuTrigger.find('.context-menu-trigger').removeClass('context-type');
};